
import { Injectable } from "@angular/core";
import { TDSNotificationService } from 'tds-ui/notification';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  constructor(
    private notification: TDSNotificationService) { }

  success() {
    this.notification.success(
      'Thông báo',
      'Thao tác thành công',
      { placement: 'bottomLeft' }
    );
  }
  error(errorString?: string) {
    this.notification.error(
      'Thông báo',
      errorString || 'Thao tác thất bại',
      { placement: 'bottomLeft' }
    );
  }

  sessionRevoked() {
    this.notification.warning(
      'Phiên đăng nhập bị thu hồi',
      'Tài khoản đã bị xóa khỏi hệ thống. Bạn sẽ được đăng xuất sau 3 giây.',
      { placement: 'topRight', duration: 6000 }
    );
  }
}
